/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the PushDevice interface.
 */
export function instanceOfPushDevice(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('deviceHash' in value) || value['deviceHash'] === undefined)
        return false;
    return true;
}
export function PushDeviceFromJSON(json) {
    return PushDeviceFromJSONTyped(json, false);
}
export function PushDeviceFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'userAgent': json['user_agent'] == null ? undefined : json['user_agent'],
        'lastUsedAt': json['last_used_at'] == null ? undefined : (new Date(json['last_used_at'])),
        'createdAt': (new Date(json['created_at'])),
        'deviceHash': json['device_hash'],
    };
}
export function PushDeviceToJSON(json) {
    return PushDeviceToJSONTyped(json, false);
}
export function PushDeviceToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'user_agent': value['userAgent'],
        'last_used_at': value['lastUsedAt'] == null ? undefined : (value['lastUsedAt'].toISOString()),
        'created_at': ((value['createdAt']).toISOString()),
    };
}
